module.exports = __webpack_public_path__ + "static/media/study 201101.8cb7885b.png";